// import { dayjs } from 'element-plus'
import { getMoment, formatDateForFilter } from '@/utils/index.js'
import moment from 'moment'
export { formatDateForFilter }
// 小结-类型
export const summaryTypeMap = [
  { label: '全部类型', value: '' },
  { label: '虚拟电话', value: 3 },
  { label: '预问诊', value: 1 },
  { label: '医助创建', value: 4 },
  { label: 'AI生成', value: 2 }
]

// 小结-添加人
export const summaryAddMap = [
  { label: '全部添加人', value: '' },
  { label: '智能医助', value: 102 },
  { label: '健管', value: 4 },
  { label: 'BD', value: 3 }
]

// // 小结-时间
// export const summaryTimeMap = [
//   { label: '全部时间', value: '' },
//   { label: '近7天', value: 0 },
//   { label: '近1个月', value: 1 }
// ]
export const rangePresets = {
  近七天: getMoment(6),
  近1个月: getMoment(5)
}
// 禁止筛选今天以后的时间
export const disabledDate = current => {
  return current && current > moment().endOf('day')
}
// 短信记录-发送状态
export const messageTypeMap = [
  { label: '全部发送状态', value: '' },
  { label: '发送成功', value: 1 },
  { label: '发送失败', value: 0 }
]

// 短信记录-时间
export const messageTimeMap = [
  { label: '全部时间', value: '' },
  { label: '近7天', value: 0 },
  { label: '近1个月', value: 1 }
]

// 通话记录-发送状态
// export const communicationTypeMap = [
//   { label: '全部通话状态', value: '' },
//   { label: '发送成功', value: 0 },
//   { label: '发送失败', value: 1 }
// ]

// 通话记录-时间
export const communicationTimeMap = [
  { label: '全部时间', value: '' },
  { label: '近7天', value: 0 },
  { label: '近1个月', value: 1 }
]

// 时间范围计算工具函数
// export const getTimeRange = type => {
//   const now = dayjs()
//   let startDate

//   if (type === 0) {
//     // 近 7 天
//     startDate = now.subtract(6, 'day').startOf('day')
//   } else if (type === 1) {
//     // 近 1 个月
//     startDate = now.subtract(29, 'day').startOf('day')
//   } else {
//     return null
//   }

//   return {
//     startTime: startDate.format('YYYY-MM-DD HH:mm:ss'),
//     endTime: now.endOf('day').format('YYYY-MM-DD HH:mm:ss')
//   }
// }
